import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../../components/layout'
import BannerCommon from '../../components/BannerCommon'
import pic1 from '../../assets/images/okremote/okremote_1.jpg'
import pic2 from '../../assets/images/okremote/okremote_2.jpg'
import pic3 from '../../assets/images/okremote/okremote_3.jpg'

const iframe = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%"
}

const News = props => (
  <Layout>
    <Helmet>
      <title>
        2020年11月26日 プレスリリース:
        オフラインのPCを遠隔操作する小型デバイスのソリューション『OKリモート』の提供を12月より開始します｜ドクターズモバイル株式会社
      </title>
      <meta name="description" content="Company Page" />
    </Helmet>
    <BannerCommon
      title="News"
      subtitle="2020年11月26日 【プレスリリース】オフラインのPCを遠隔操作する小型デバイスのソリューション『OKリモート』の提供を12月より開始します"
    />

    <div id="main" className="alt">
      <section>
        <div className="inner">
          <h2 id="content">
            オフラインのPCを遠隔操作する小型デバイス+ソリューション『OKリモート』を開発
            <br />
            <span style={{ fontSize: '0.7em' }}>
              〜デバイスを送付　USBを差し込むだけで開始する、新しいサポート体験を提唱〜
            </span>
          </h2>
          <h3 style={{ textAlign: 'right' }}>2020年11月26日</h3>
          <p>
            ドクターズモバイル株式会社（本社：東京都港区、代表取締役：医師 中尾
            彰宏）は、IT機器を遠隔操作するデバイスを用いたソリューション、『OKリモート』を本日発表いたします。
          </p>

          <p>
            『OKリモート』は小型のネットワークデバイスを利用、USBで接続して使う全く新しい発想で開発されたソリューションです。
            多様な業種・サービス向けにBtoBおよびBtoCで提供されます。
          </p>
          <p style={{ textAlign: 'center' }}>
            <img src={pic1} style={{ width: '100%', maxWidth: '640px' }} />
          </p>

          <p>『OKリモート』の発売日は12月1日です。</p>

          <h4>■「OKリモート」の利用事例</h4>
          <p>
            事例1. 医療機器メーカーや、ソフトウェアベンダー
            <ol>
              <li>
                営業スタッフが客先を訪問する際のサポートエンジニアによる遠隔機器操作の支援
              </li>
              <li>
                ネットワーク接続が禁止されている医療用機器等に対するデモ・操作アシスト・故障時のサポート
              </li>
            </ol>
          </p>
          <p>
            事例2. 大企業一般
            <ol>
              <li>
                大企業における、個人持ち出しPCのサポート。とくにネットワークが不調なとき、社内SEに助けを求めたい場合
              </li>
              <li>今般のコロナ禍による、リモートワーク時のPCトラブル対応</li>
            </ol>
          </p>
          <p>
            事例3. PCの販売店
            <ol>
              <li>
                PCを購入した初心者ユーザーに対し、インターネット接続までの手順を遠隔でサポート
              </li>
            </ol>
          </p>
          <p>
            事例4. インフラエンジニア一般
            <ol>
              <li>サーバーの初期設定を遠隔操作で行いたい場合</li>
            </ol>
          </p>
          <p>
            ドクターズモバイル株式会社の代表取締役：中尾
            彰宏は以下のように述べています。
          </p>
          <p>
            「医療の現場においては、電子カルテ端末などインターネットに繋げないオフライン機器が業務で多用されています。とくに昨今のコロナ禍で、遠隔サポートに関する強い要望があり、より簡単でセキュリティが担保できるツールとして開発しました。少しでも医療現場の助けになればと思っています。」
          </p>
          <p>
            ドクターズモバイルは今後も現場の視点から、ITを通じて業務改革に役立つサービスを提供してまいります。
          </p>
        </div>
      </section>
      <section>
        <div className="inner">
          <p style={{ textAlign: 'center' }}>
            <img src={pic2} style={{ width: '100%', maxWidth: '640px' }} />
            <div>『OKリモート』の外観</div>
          </p>
          <p style={{ textAlign: 'center' }}>
            <img src={pic3} style={{ width: '100%', maxWidth: '640px' }} />
            <div>『OKリモート』をPCに接続した様子</div>
          </p>
        </div>
      </section>
      <section>
        <div className="inner">
          <p style={{ textAlign: 'center' }}>参考資料</p>
          <h4>■『OKリモート』の背景と開発の経緯</h4>
          <p>
            ドクターズモバイルは、医療機関や介護施設のITに関する開発・支援を行う企業です。
          </p>
          <p>
            かねてより医療機関ではセキュリティ上の理由から、ネットワークに接続されていない/ネットワーク接続が禁止されているPCや医療系IT機器が散見されることに着目していました。
          </p>
          <p>
            新型コロナウイルス感染症の感染拡大に伴い、医療機関や介護福祉施設への立入りを慎むべき状況が続いています。
          </p>
          <p>
            とくに電子カルテ端末や医療機器のトラブル時のサポート体制は十分とは言えません。現状では営業スタッフが訪問し、さらにエンジニアのサポートを電話で受けるような状況にありました。
          </p>
          <p>
            ドクターズモバイルは、医療現場に遠隔サポートを支援するサービスが必須であると考えて『OKリモート』の開発に着手しました。同時にこのサービスが、多様な業界で、PCやIT機器の管理やサポートに関する多くの問題を解決することがわかり、さらに開発をすすめ、発売を決定しました。
          </p>
          <h4>■『OKリモート』の特長</h4>
          <ul style={{padding: '5px 30px'}}>
            <li>
              操作者はインターネット接続したEdge, Chrome, Safari,
              Firefox等のブラウザ上で操作が可能なため、特別な機器を必要としない。また低コストで利用できる
            </li>
            <li>
              被操作端末にソフトウェアのインストールが不要（USBキーボード、USBマウスとしてPCに認識）なため、システムダウン時にも利用が可能。また、デバイスの配送のみでの遠隔サポートが可能
            </li>
            <li>
              『OKリモート』デバイス本体のカメラで、被操作PCのディスプレイを撮影するため、ディスプレイ画面を見ながら、遠隔でマウスやキーボード操作が可能
            </li>
            <li>
              被操作端末がネットワークに接続されていなくても操作が可能なため、OS起動前の機器操作サポート、無線LAN接続不良時のサポートが可能
            </li>
            <li>
              OSアップデートなど予期せぬOSの再起動時にも状況確認や画面操作が可能
            </li>
            <li>
              ・遠隔PC操作が必要ない場合にはセキュアなウェブカメラとして利用可能
            </li>
          </ul>

          <h4> ■『OKリモート』が解決できる問題点/想定される利用法</h4>
          <ul style={{padding: '5px 30px'}}>
            <li>インターネットに接続されていない端末の操作やサポート</li>
            <li>
              意図せずインターネットに接続できなくなってしまった端末の操作やサポート
            </li>
            <li>
              新たなソフトのインストールが禁止されている端末の操作やサポート
            </li>
            <li>
              ソフトのインストール方法が分からないユーザーへの遠隔サポート
            </li>
            <li>訪問できない現場や遠隔サービスのサポート</li>
            <li>
              サポートエンジニアが拠点に待機し、セールスエンジニアが現地訪問した場合の遠隔サポート
            </li>
          </ul>

          <h4>■『OKリモート』製品概要</h4>
          <p style={{padding: '5px 30px'}}>
            商品名： OKリモート（読み：オーケーリモート） 価格：オープンプライス
            <br />
            接続方式：USB接続（USBキーボード/USBマウスと認識)
            <br />
            カメラ解像度：800万画素
            <br />
            被操作端末利用環境：Windows、Mac、Linux等
            <br />
            *USB接続可能な組込機器等にも対応可能 <br />
            操作端末利用環境：Edge, Chrome, Safari,
            Firefox等の最新のブラウザが動作する端末
            <br />
            デバイス本体の通信方法: Bluetooth, Wi-Fi, LTE* <br />
            サイズ： 113mm x 80mm x 50mm<br />
            *LTE接続用モジュールは2021年2月頃に別途発売予定
          </p>
          <div style={{ position: "relative", height: 315, maxWidth: 560, margin: "0 auto" }}>
            <p style={{textAlign:'center'}}>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/oeS3XzWmsVw" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style={iframe}></iframe>
            </p>
          </div>
        </div>
      </section>
    </div>
  </Layout>
)

export default News
